<template>
    <nuxt-link to="/" class="group">
        <p class="text-2xl font-bold dark:text-white">
            <span class="text-lightula-blue dark:text-darkula-blue group-hover:animate-pulse">_</span>vetrov.dev
        </p>
    </nuxt-link>
</template>